module.exports = __webpack_public_path__ + "vi.dba63d733ebf1fb05e13.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/vi.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/vi.svg
// module chunks = styles